import React, { Component } from 'react'
import { Index } from 'react-instantsearch-dom'
import ArticleHits from './article-hits'

export default class ArticleResults extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const index = this.props.algoliaConfig.articles
    return (
      <div className="article-result-grid">
        <Index indexName={index}>
          <ArticleHits type={`articles`} />
        </Index>
      </div>
    )
  }
}
